// Ticket: the Events bar colour is fixed per rank position (1st/2nd/3rd),
// not per company — confirmed 3 fixed base colours.
export const RANK_COLOR = {
  1: "var(--color-primary-500, #9645FF)",
  2: "var(--color-fuchsia-500, #D946EF)",
  3: "var(--color-cyan-800, #00A2B8)",
};

export const DEFAULT_RANK_COLOR = RANK_COLOR[1];
